._Summary_w27cp_1 {
  font-weight: 700;
}

._FilterOptions_w27cp_5 {
  margin-top: 0.5em;
}
